import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Gift, Ticket, CreditCard as CardIcon, Toilet, Accessibility, Banknote, Wifi, Award } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

const services = [
  { icon: Gift, title: "Geschenkservice", desc: "Mit dem Geschenkservice erhalten Sie eine praktische Möglichkeit, anderen eine Freude zu bereiten." },
  { icon: Ticket, title: "Marktgutscheine", desc: "Marktgutscheine von Rewe Kotlarski eignen sich als flexible Geschenkidee für viele Anlässe." },
  { icon: CardIcon, title: "Gutscheinkarten", desc: "Im Markt erhalten Sie Gutscheinkarten, die sich unkompliziert als kleine Aufmerksamkeit verschenken lassen." },
  { icon: Toilet, title: "Kunden-WC", desc: "Ein Kunden-WC steht Ihnen während Ihres Einkaufs direkt im Markt zur Verfügung und ergänzt den Service vor Ort." },
  { icon: Accessibility, title: "Barrierefreier Markt", desc: "Der Markt ist barrierefrei gestaltet und ermöglicht einen möglichst unkomplizierten Einkauf." },
  { icon: Banknote, title: "Cashback", desc: "Bargeldabhebungen sind bereits ab 0,01 Euro Einkaufswert bis zu einem Betrag von 200 Euro möglich." },
  { icon: Wifi, title: "Gratis-WLAN", desc: "Nutzen Sie während Ihres Aufenthalts im Markt das kostenlos bereitgestellte WLAN." },
  { icon: Award, title: "Generationsfreundlich", desc: "Rewe Kotlarski ist bis 2027 als „Generationsfreundlich“ zertifiziert und entsprechend ausgezeichnet." },
];

const Service = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <>
      <Seo title="Service & Leistungen | Rewe Kotlarski Meerbusch" description="Geschenkservice, Marktgutscheine, Cashback, Gratis-WLAN, Kunden-WC und ein barrierefreier, generationsfreundlicher Markt bei Rewe Kotlarski in Meerbusch." />
      <PageHeader
        tag="Service"
        title="Praktische Services für Ihren Einkauf"
        subtitle="Rewe Kotlarski bietet Geschenkservice, Gutscheine, Cashback, Gratis-WLAN, Kunden-WC und einen barrierefreien Markt."
        heroImage="/images/kasse-team.webp"
        drawIconVariant="star"
        objectPosition="center 12%"
      />

      <section ref={ref} className="py-20 px-6 md:px-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.08 * i }}
              className="bg-card border border-border p-8 flex flex-col items-center text-center md:items-start md:text-left h-full hover:bg-secondary/50 transition-colors duration-300"
            >
              <s.icon className="w-8 h-8 text-primary-bright mb-5 shrink-0" aria-hidden="true" />
              <h2 className="font-display text-xl font-semibold text-foreground mb-2" style={{ textWrap: "pretty" as any }}>{s.title}</h2>
              <p className="text-muted-foreground font-body leading-relaxed" style={{ textWrap: "pretty" as any }}>{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Service;